import axios from 'axios';
import config from 'config';

const token = localStorage.getItem('token');

export default axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  },
});
